export default "__VITE_ASSET__7TpMz2XI__"